import React, { Component } from 'react';
import Group from "../../../ducks/Groups";
import User from "../../../ducks/Users";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from 'react-router-dom';
import ToggleButton from 'react-toggle-button'
import TextFieldGroup from '../../common/TextFieldGroup';
import editIcon from "../../../assets/img/ic_edit.png";
import { UncontrolledCollapse } from 'reactstrap';
import './index.css'
import camera from "../../../assets/img/ic_camera.png"
import forwardIcon from '../../../assets/img/ic_forward.png';
import toastr from "toastr";
import Slider from 'rc-slider';
const colors = {
  activeThumb: {
    base: '#fff',
  },
  inactiveThumb: {
    base: '#fff',
  },
  active: {
    base: '#03ABCE',
    hover: '#03ABCE',
  },
  inactive: {
    base: 'rgb(65,66,68)',
    hover: 'rgb(95,96,98)',
  }
};

const notificationnObj = {
  HIGH_HUMIDITY_DETECTED: false,
  HIGH_TEMPERATURE_DETECTED: false,
  LOW_HUMIDITY_DETECTED: false,
  LOW_TEMPERATURE_DETECTED: false
}

const { Range } = Slider;

class GroupAccount extends Component {
  constructor(props) {
    const groupData = JSON.parse(localStorage.getItem("groupInfo"));

    super(props);
    this.state = {
      name: "",
      image: camera,
      errors: {},
      groupId: "",
      toggle: true,
      overSpeedingThreshold: null,
      lowIntensityOverSpeeding: null,
      highIntensityOverSpeeding: null,
      fatigueThreshold: null,
      restAfterFatigueThreshold: null,
      nrConfig: null,
      notifications: {...notificationnObj, warningPopup: false, buzzer: false},
      sms: notificationnObj,
      email: notificationnObj,
      drivingScoreSetting: {
        harshAcceleration: false,
        harshBrake: false,
        overSpeeding: false,
        sharpTurn: false,
        unFastenSeatBelt: false,
      },
      overSpeedingOpen: false,
      humidityOpen: false,
      notificationsOpen: false,
      temperatureOpen: false,
      drivingScoresOpen: false,
      nrToggleOpen: false,
      tmin: -30,
      tmax: 70,
      hmin: -40,
      hmax: 100,
      tmaxValue:0,
      tminValue:0,
      hmaxValue:0,
      hminValue:0
    }
  }
  

  async componentDidMount() {
    const { groupId, companyId } = JSON.parse(localStorage.getItem("companyInfo"));
    let {user} = JSON.parse(localStorage.getItem('user'));
    await this
    .props
    .actions
    .getSingleToUpdate(groupId);
    await this
    .props
    .userActions
    .getUser(user._id);

    this.setState({
      ...this.state,
      tmaxValue : this.props.group.highTemperatureThreshold,
      tminValue : this.props.group.lowTemperatureThreshold,
      hmaxValue : this.props.group.highHumidityThreshold,
      hminValue : this.props.group.lowHumidityThreshold,
      tmin : this.props.group.tmin || -30,
      tmax : this.props.group.tmax || 70,
      hmin : this.props.group.hmin || -40,
      hmax : this.props.group.hmax || 100,
      sms :{
        HIGH_HUMIDITY_DETECTED: this.props.smsSetting ? this.props.smsSetting['HIGH_HUMIDITY_DETECTED']  : false,
        HIGH_TEMPERATURE_DETECTED:  this.props.smsSetting ? this.props.smsSetting['HIGH_TEMPERATURE_DETECTED']  : false,
        LOW_HUMIDITY_DETECTED:  this.props.smsSetting ? this.props.smsSetting['LOW_HUMIDITY_DETECTED']  : false,
        LOW_TEMPERATURE_DETECTED:  this.props.smsSetting ? this.props.smsSetting['LOW_TEMPERATURE_DETECTED']  : false
      },
      email : {
        HIGH_HUMIDITY_DETECTED: this.props.emailSetting ? this.props.emailSetting['HIGH_HUMIDITY_DETECTED']  : false,
        HIGH_TEMPERATURE_DETECTED:  this.props.emailSetting ? this.props.emailSetting['HIGH_TEMPERATURE_DETECTED']  : false,
        LOW_HUMIDITY_DETECTED:  this.props.emailSetting ? this.props.emailSetting['LOW_HUMIDITY_DETECTED']  : false,
        LOW_TEMPERATURE_DETECTED:  this.props.emailSetting ? this.props.emailSetting['LOW_TEMPERATURE_DETECTED']  : false
      }

  });
  }

  onSliderChangeTemp = (value) => {
    this.setState({...this.state, tminValue :value[0] , tmaxValue: value[1]});

  };

  onSliderChangeHumidity = (value) => {
    this.setState({...this.state, hminValue : value[0], hmaxValue: value[1]});
  };

  onSliderChangeSubmitTemperature = async () => {
    const { groupId, companyId } = JSON.parse(localStorage.getItem("companyInfo"));
    let body = {
        highTemperatureThreshold:this.state.tmaxValue,
        lowTemperatureThreshold:this.state.tminValue
    }
    await this
        .props
        .actions
        .UpdateSubGroup(body,groupId);
    toastr.success("Group Updated Successfully!");
  }

  onSliderChangeSubmitHumidity = async () => {
    const { groupId, companyId } = JSON.parse(localStorage.getItem("companyInfo"));
    let body = {
        highHumidityThreshold:this.state.hmaxValue,
        lowHumidityThreshold:this.state.hminValue
    }
    await this
        .props
        .actions
        .UpdateSubGroup(body,groupId);
    toastr.success("Group Updated Successfully!");
  };

  smsToggle(data, value) {
    let sms = this.state.sms;
    sms[data] = false;
    sms[data] = !value;
    this.setState({
      ...this.state,
      sms
    });
  };

  emailToggle(data, value) {
    let email = this.state.email;
    email[data] = false;
    email[data] = !value;
    this.setState({
      ...this.state,
      email
    });
  };

  onSaveSmsSetting = async () => {
    await this.props.userActions.UpdateSmsEmailSetting({'sms':this.state.sms,'email':this.state.email});
    toastr.success("Notification Settings has Updated Successfully!");
  };

  render() {

    let trangeValue = [this.state.tminValue, this.state.tmaxValue];
    let hrangeValue = [this.state.hminValue, this.state.hmaxValue];
    let { sms, email, temperatureOpen, humidityOpen, notificationsOpen} = this.state;

    return (
      <div>
        <div className="account-center">
          <div className="row group-info">
              <a className='image-input'>

                <label htmlFor="image-input">
                  <img src={this.state.image || camera} alt="Company" className='group-image' />
                </label>
              </a>
              <span>
                <p className="group-name">{this.props.group.name}</p>
              </span>
              <span>
                <Link className="edit-icon" to={`/account/update/${this.props.group.id}`}>
                  <img src={editIcon} alt="edit" />
                </Link>
              </span>
              </div>

          <section>
            <div className="notification-rectangle">
            <a id="temperatureToggle" onClick={() => this.setState({ ...this.state, temperatureOpen: !this.state.temperatureOpen })}>
              <img alt="" className={temperatureOpen ? 'list-view-transform width18' : 'width18'} src={forwardIcon} />
            </a>
            <p>Temperature Threshold</p>
            <UncontrolledCollapse toggler="#temperatureToggle" className="collapse-nav">
              <ul>
                <li className="notifications-list">

                  <div className="width100">
                    <div style={{display:'flex', flexDirection:'column'}}>
                      <label>Upper Limit : {this.state.tmaxValue}</label>
                      <label>Lower Limit : {this.state.tminValue}</label>
                    </div>
                    <Range
                          value={trangeValue}
                          min={this.state.tmin}
                          max={this.state.tmax}
                          onChange={this.onSliderChangeTemp}
                        />
                  </div>

                </li>
                <li className="notifications-list">

                  <div>
                    <button className="primary-btn btn blue-bg" onClick={this.onSliderChangeSubmitTemperature.bind(this)}>Save</button>
                  </div>
                </li>

              </ul>
            </UncontrolledCollapse>
            </div>
          </section>
          <section>
            <div className="notification-rectangle">
            <a id="humidityToggle" onClick={() => this.setState({ ...this.state, humidityOpen: !this.state.humidityOpen })}>
              <img alt="" className={humidityOpen ? 'list-view-transform width18' : 'width18'} src={forwardIcon} />
            </a>
            <p>Humidity Threshold</p>
            <UncontrolledCollapse toggler="#humidityToggle" className="collapse-nav">
              <ul>
                <li className="notifications-list">

                  <div className="width100">
                  <div style={{display:'flex', flexDirection:'column'}}>
                      <label>Upper Limit : {this.state.hmaxValue}</label>
                      <label>Lower Limit : {this.state.hminValue}</label>
                    </div>
                    <Range
                          value={hrangeValue}
                          min={this.state.hmin}
                          max={this.state.hmax}
                          onChange={this.onSliderChangeHumidity}
                        />
                  </div>

                </li>
                <li className="notifications-list">
                  <div>
                    <button className="primary-btn btn blue-bg" onClick={this.onSliderChangeSubmitHumidity.bind(this)}>Save</button>
                  </div>
                </li>

              </ul>
            </UncontrolledCollapse>
            </div>
          </section>

          <section>
            {
              <div className="notification-rectangle">
                <a id="notificationsToggle" onClick={() => this.setState({ ...this.state, notificationsOpen: !this.state.notificationsOpen })}>
                  <img alt="" className={notificationsOpen ? 'list-view-transform width18' : 'width18'} src={forwardIcon} />
                </a>
                <p>Notifications</p>

                <UncontrolledCollapse toggler="#notificationsToggle" className="collapse-nav">
                  <ul>
                    <div className="notif-label">
                      <div></div>
                        <label>SMS</label>
                        <label>Email</label>
                    </div>

                    <li className="notifications-list">
                      <span>LOW TEMPERATURE DETECTED</span>
                      <div className="items-tog"></div>
                      <div className="items-tog"></div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={sms?.LOW_TEMPERATURE_DETECTED || false}
                            onToggle={this.smsToggle.bind(this, "LOW_TEMPERATURE_DETECTED")}
                          />
                        </div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={email?.LOW_TEMPERATURE_DETECTED || false}
                            onToggle={this.emailToggle.bind(this, "LOW_TEMPERATURE_DETECTED")}
                          />
                        </div>
                    </li>

                    <li className="notifications-list">
                      <span>LOW HUMIDITY DETECTED</span>
                      <div className="items-tog"></div>
                      <div className="items-tog"></div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={sms?.LOW_HUMIDITY_DETECTED || false}
                            onToggle={this.smsToggle.bind(this, "LOW_HUMIDITY_DETECTED")}
                          />
                        </div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={email?.LOW_HUMIDITY_DETECTED || false}
                            onToggle={this.emailToggle.bind(this, "LOW_HUMIDITY_DETECTED")}
                          />
                        </div>
                    </li>

                    <li className="notifications-list">
                      <span>HIGH TEMPERATURE DETECTED</span>
                      <div className="items-tog"></div>
                      <div className="items-tog"></div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={sms?.HIGH_TEMPERATURE_DETECTED || false}
                            onToggle={this.smsToggle.bind(this, "HIGH_TEMPERATURE_DETECTED")}
                          />
                        </div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={email?.HIGH_TEMPERATURE_DETECTED || false}
                            onToggle={this.emailToggle.bind(this, "HIGH_TEMPERATURE_DETECTED")}
                          />
                        </div>
                    </li>
                    <li className="notifications-list">
                      <span>HIGH HUMIDITY DETECTED</span>
                      <div className="items-tog"></div>
                      <div className="items-tog"></div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={sms?.HIGH_HUMIDITY_DETECTED || false}
                            onToggle={this.smsToggle.bind(this, "HIGH_HUMIDITY_DETECTED")}
                          />
                        </div>
                        <div className="items-tog">
                          <ToggleButton
                            colors={colors}
                            value={email?.HIGH_HUMIDITY_DETECTED || false}
                            onToggle={this.emailToggle.bind(this, "HIGH_HUMIDITY_DETECTED")}
                          />
                        </div>
                    </li>
                    <li className="notifications-list ">
                    <div className="items-tog"></div>
                    <div className="items-tog"></div>
                    <div className="items-tog"></div>
                    <div className="items-tog"></div>
                    <div className="items-tog"></div>
                      <div className="items-tog"></div>
                      <div>
                        <button className="primary-btn btn blue-bg" onClick={this.onSaveSmsSetting.bind(this)}>Save</button>
                      </div>
                    </li>
                  </ul>
                </UncontrolledCollapse>

              </div>
            }
          </section>
        </div>
      </div>
    );
  }
}

GroupAccount.propTypes = {};
GroupAccount.defaultProps = {};

const mapStateToProps = state => ({
  group: state.groups.group, notifications: state.users.notificationsSetting,
  smsSetting: state.users.user.smsSetting, emailSetting: state.users.user.emailSetting,
  drivingScoreSetting: state.groups.scoreSetting, permissions: state.permissions
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Group.creators, dispatch),
  userActions: bindActionCreators(User.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupAccount);
